import { render, staticRenderFns } from "./AnalysisMobile.vue?vue&type=template&id=3b810b28&scoped=true"
import script from "./AnalysisMobile.vue?vue&type=script&lang=js"
export * from "./AnalysisMobile.vue?vue&type=script&lang=js"
import style0 from "./AnalysisMobile.vue?vue&type=style&index=0&id=3b810b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b810b28",
  null
  
)

export default component.exports